import React, { useContext, useEffect, useState } from "react";
import { FaCartArrowDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AppContext } from "./Contaxt";
import { toast } from "react-toastify";
import Banner from "../Compunents/Banner";

function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setData } = useContext(AppContext);

  const data = async () => {
    setLoading(true);

    const responce = await fetch("https://fakestoreapi.com/products");
    const products = await responce.json();

    setProducts(products);

    setLoading(false);
  };
  useEffect(() => {
    data();
  }, []);

  const handleClick = (id) => {
    const prroduct = products.find((p) => p.id === id);

    const item = localStorage.getItem("items");
    if (!item) {
      localStorage.setItem("items", JSON.stringify([prroduct]));
      setData([prroduct]);
    } else {
      const newitem = JSON.parse(item);
      if (
        newitem.find((p) => {
          return p.id === prroduct.id;
        })
      )
        return toast.error("Item allready exist in cart!", {
          position: "top-right",
        });
      newitem.push(prroduct);
      localStorage.setItem("items", JSON.stringify(newitem));
      setData(newitem);
    }
    toast.success("Item added to cart", {
      position: "top-right",
    });
  };

  return (
    <>
      <Banner />
      <div className="container text-center backcolor">
        {loading ? (
          "Loading...."
        ) : (
          <div className="row">
            <h1
              style={{
                fontFamily: "Reddit Sans Condensed",
                fontWeight: "bold",
                textShadow: "0 0 20px 10px white",
              }}
            >
              Our Products
            </h1>

            <div className="cart-data">
              {products.map((product) => {
                return (
                  <div
                    key={product.id}
                    className="card my-3 p-3"
                    style={{
                      width: "18rem",
                      height: "540px",
                      cursor: "pointer",
                    }}
                  >
                    <Link to={"/" + product.id}>
                      <img
                        src={product.image}
                        className="card-img-top"
                        alt="..."
                        style={{
                          width: "100%",
                          height: "300px",
                          objectFit: "contain",
                        }}
                      />
                    </Link>

                    <div className="card-body">
                      <h5 className="card-title">
                        {product.category.substr(0, 70)}
                      </h5>
                      <strong>$ {product.price}</strong>
                      <p>{product.title.substr(0, 60)}...</p>

                      <button
                        className="btn btn-primary"
                        onClick={() => handleClick(product.id)}
                      >
                        Add to cart {<FaCartArrowDown />}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Home;
